import { api } from './api';

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const raw = window.atob(base64);
  const output = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) output[i] = raw.charCodeAt(i);
  return output;
}

export function pushSupported() {
  return typeof window !== 'undefined' && 'serviceWorker' in navigator && 'PushManager' in window && 'Notification' in window;
}

export function pushPermission() {
  if (!pushSupported()) return 'unsupported';
  return Notification.permission; // 'default' | 'granted' | 'denied'
}

export async function registerServiceWorker() {
  if (!pushSupported()) return null;
  try {
    const reg = await navigator.serviceWorker.register('/sw.js');
    return reg;
  } catch (e) {
    return null;
  }
}

/** Prompts for permission (if default), creates/updates the push subscription,
 *  POSTs it to our backend. Returns { ok, state }. */
export async function subscribeToPush() {
  if (!pushSupported()) return { ok: false, state: 'unsupported' };
  const perm = await Notification.requestPermission();
  if (perm !== 'granted') return { ok: false, state: perm };

  const reg = (await navigator.serviceWorker.getRegistration()) || (await registerServiceWorker());
  if (!reg) return { ok: false, state: 'sw-failed' };

  // Fetch VAPID public key from the backend
  let publicKey;
  try {
    const res = await api.get('/push/vapid-public-key');
    publicKey = res.data.public_key;
  } catch (e) {
    return { ok: false, state: 'vapid-fetch-failed' };
  }

  let sub;
  try {
    sub = await reg.pushManager.getSubscription();
    if (!sub) {
      sub = await reg.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(publicKey),
      });
    }
  } catch (e) {
    return { ok: false, state: 'subscribe-failed' };
  }

  try {
    const json = sub.toJSON();
    await api.post('/push/subscribe', {
      endpoint: json.endpoint,
      keys: json.keys,
      expirationTime: json.expirationTime,
    });
  } catch (e) {
    return { ok: false, state: 'server-save-failed' };
  }
  return { ok: true, state: 'granted' };
}

export async function unsubscribeFromPush() {
  if (!pushSupported()) return { ok: false };
  const reg = await navigator.serviceWorker.getRegistration();
  if (!reg) return { ok: false };
  const sub = await reg.pushManager.getSubscription();
  if (!sub) return { ok: true };
  try {
    const endpoint = sub.endpoint;
    await sub.unsubscribe();
    try { await api.post('/push/unsubscribe', { endpoint }); } catch (e) {}
    return { ok: true };
  } catch (e) {
    return { ok: false };
  }
}
